var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalOrdersNd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#EFEFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1055_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2542 21.9163C24.9417 21.9163 25.5467 21.5405 25.8584 20.9722L29.14 15.023C29.4792 14.418 29.0392 13.6663 28.3425 13.6663H14.7759L13.9142 11.833H10.9167V13.6663H12.75L16.05 20.6238L14.8125 22.8605C14.1434 24.0888 15.0234 25.583 16.4167 25.583H27.4167V23.7497H16.4167L17.425 21.9163H24.2542ZM15.6467 15.4997H26.7842L24.2542 20.083H17.8192L15.6467 15.4997ZM16.4167 26.4997C15.4084 26.4997 14.5925 27.3247 14.5925 28.333C14.5925 29.3413 15.4084 30.1663 16.4167 30.1663C17.425 30.1663 18.25 29.3413 18.25 28.333C18.25 27.3247 17.425 26.4997 16.4167 26.4997ZM25.5834 26.4997C24.575 26.4997 23.7592 27.3247 23.7592 28.333C23.7592 29.3413 24.575 30.1663 25.5834 30.1663C26.5917 30.1663 27.4167 29.3413 27.4167 28.333C27.4167 27.3247 26.5917 26.4997 25.5834 26.4997Z",
    fill: "#9C9C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1055_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrdersNd);
export default __webpack_public_path__ + "static/media/TotalOrdersND.bcab0a465f80ba12ddccc8735d330613.svg";
export { ForwardRef as ReactComponent };